import { Reducer } from "redux";
import Account from "../../models/account/Account";
import { LogoutActionTypes } from "../auth/types";
import { ActivateFullProfileActionTypes, RefreshProfilesActionTypes, GetAccountActionTypes, GetIsFullProfileActivationInProgressActionTypes } from "./types";

export interface AccountState {
    account?: Account;
}

const unloadedState: AccountState = { account: undefined };

export const accountReducer: Reducer<AccountState> = (state: AccountState | undefined, action): AccountState => {
    if (!state) {
        return unloadedState;
    }

    switch (action.type) {
        case GetAccountActionTypes.SUCCESS:
            return { ...state, account: { ...action.payload } };
        case LogoutActionTypes.SUCCESS:
            return { ...state, account: undefined };
        case ActivateFullProfileActionTypes.SUCCESS:
            return { ...state, account: { ...state.account!, isFullProfileActivationInProgress: true } };
        case GetIsFullProfileActivationInProgressActionTypes.SUCCESS:
            return { ...state, account: { ...state.account!, isFullProfileActivationInProgress: action.payload.isFullProfileActivationInProgress } };
        case RefreshProfilesActionTypes.SUCCESS:
            return { ...state, account: { ...state.account!, isRefreshProfilesInProgress: true } };
        default:
            return state;
    }
};
